const fp = [0, 1, 2]

export const fakePages = fp;

export const offset = (pageNumber) => pageNumber - fakePages.filter(fakePage => pageNumber > fakePage).length;

// inverse offset is used for page hopping. eg if user says go to page 5, inverseOffset will take them to page 7.
export const inverseOffset = (pageNumber) => pageNumber + fp.filter(fakePage => pageNumber > fakePage).length;
